'use es6';

import styled from 'styled-components';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { INPUT_STYLES } from './constants';
const Checkbox = styled(UICheckbox).withConfig({
  displayName: "Checkbox",
  componentId: "vbvi7b-0"
})(["", ""], INPUT_STYLES);
export default Checkbox;